"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var RichTextItemSetters_1 = require("./RichTextItemSetters");
/**
 * ensure the componets have a type (we default to mark) as well as ensuring there is an id
 * @param components which set of component on which we should operate
 */


var withDefaults = function withDefaults(components) {
  var withDefaultType = function withDefaultType(Component) {
    return (// eslint-disable-next-line no-prototype-builtins
      Component.hasOwnProperty('type') ? Component : RichTextItemSetters_1.asMark(Component)
    );
  };

  return Object.getOwnPropertyNames(components).reduce(function (acc, id) {
    var _a;

    return __assign(__assign({}, acc), (_a = {}, _a[id] = lodash_1.flow(withDefaultType, RichTextItemSetters_1.withId(id))(acc[id]), _a));
  }, components);
};

exports.default = withDefaults;